<template>
  <div class="hospital">
      <div class="title">
          <span></span>
          <p class="tit">接种疫苗者身份信息：</p>
      </div>
      <div class="info"><p>姓名：</p><span>{{infoMsg.name}}</span></div>
      <div class="info"><p>证件类型：</p><span>{{infoMsg.identity_type_display}}</span></div>
      <div class="info"><p>证件号码：</p><span>{{infoMsg.identity_code}}</span></div>
      <div class="info"><p>联系方式：</p><span>{{infoMsg.phone}}</span></div>
      <div class="title">
          <span></span>
          <p class="tit">就诊需求</p>
      </div>
      <div class="tit2 tits"><p>1. 填写就诊医院：<span>（*必填）</span></p></div>
      <div class="text"><input type="text" v-model="inputHosp" class="address" placeholder="请填写就诊医院"></div>
      <div class="tit2"><p>2. 填写就诊科室：<span>（*必填）</span></p></div>
      <div class="text"><input type="text" v-model="inputKS" class="address" placeholder="请填写就诊科室"></div>
      <div class="tit2"><p>3. 填写疾病描述：<span>（*必填）</span></p></div>
      <div class="text"><textarea placeholder="请描述疾病症状" v-model="inputInfo" ></textarea></div>
      <div class="tit2"><p>4. 填写就诊卡号或医保卡卡号：<span>（*必填）</span></p></div>
      <div class="text"><input type="text" v-model="inputNum" class="address" placeholder="请填写就诊卡号或医保卡卡号"></div>
      <div class="tit2"><p>5. 就诊类型：<span>（*必选）</span></p></div>
      <label><input v-model="radioVal" type="radio" value="FIRST" checked @change="getRadioVal">初诊</label>
      <label><input v-model="radioVal" type="radio" value="FURTHER" @change="getRadioVal">复诊</label>
      <div class="tit2"><p>6. 费用类型：<span>（*必选）</span></p></div>
      <label><input v-model="radioVal2" type="radio" value="SELF_PAY" checked @change="getRadioVal2">自费</label>
      <label><input v-model="radioVal2" type="radio" value="SOCIAL_INSURANCE_PAY" @change="getRadioVal2">医保</label>
      <div class="tit2"><p>7. 预约时间段<span>（*必选）</span></p></div>
      <div class="text"><input type="text" v-model="inputTime" class="address" @click="calendar()"  placeholder="请选择您方便就诊的时间段（以1周时间计算）"></div>
      <div class="tit2"><p>8. 就诊需求备注<span></span></p></div>
      <div class="text"><textarea placeholder="如有特殊要求，请填写此处备注" v-model="inputTip" >
      </textarea></div>
      <div class="btn">
        <button @click="confirm()">确认并提交</button>
      </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      inputHosp: "", //就诊医院
      inputKS: "", //就诊科室
      inputInfo: "", //描述
      inputNum: "", //卡号
      radioVal: "FIRST", //初诊
      radioVal2: "SELF_PAY", //自费
      inputTime: "", //时间
      inputTip: "" ,//备注
      infoMsg:""
    };
  },
  created() {
    let hospMsg = sessionStorage.getItem("hospital");
    if (hospMsg != "" && hospMsg != null) {
      this.inputHosp = hospMsg;
    }
    let calendarDate = sessionStorage.getItem("calendar");
    if (calendarDate != "" && calendarDate != null) {
      this.inputTime = calendarDate;
    }
    let inputHospData = sessionStorage.getItem("inputHosp");
    if (inputHospData != "" && inputHospData != null) {
      this.inputHosp = inputHospData;
    }
    let inputKSData = sessionStorage.getItem("inputKS");
    if (inputKSData != "" && inputKSData !=null) {
      this.inputKS = inputKSData;
    }
    let inputInfoData = sessionStorage.getItem("inputInfo");
    if (inputInfoData != "" && inputInfoData != null) {
      this.inputInfo = inputInfoData;
    }
    let inputNumData = sessionStorage.getItem("inputNum");
    if (inputNumData != "" && inputNumData != null) {
      this.inputNum = inputNumData;
    }
    let inputTipData = sessionStorage.getItem("inputTip");
    if (inputTipData != "" && inputTipData != null) {
      this.inputTip = inputTipData;
    }
    axios.get(HPV_URL + "/api/member/").then(res => {
      this.infoMsg = res.data.info;
      console.log(res.data.info);
    });
  },
  methods: {
    getRadioVal() {},
    getRadioVal2() {},
    calendar() {
      this.setItem();
      this.$router.push({
        path: "/calendar",
        query:{
          channel:'Green'
        }
      });
    },
    confirm() {
      let id = sessionStorage.getItem("member_id");
      if (this.inputHosp == "" || this.inputHosp == null) {
        this.$toast.text("请填写就诊医院");
      } else if (this.inputKS == "" || this.inputKS == null) {
        this.$toast.text("请填写就诊科室");
      } else if (this.inputInfo == "" || this.inputInfo == null) {
        this.$toast.text("请描述疾病症状");
      } else if (this.inputNum == "" || this.inputNum == null) {
        this.$toast.text("请填写就诊卡号或医保卡卡号");
      } else if (this.inputTime == "" || this.inputTime == null) {
        this.$toast.text("请选择您方便就诊的时间段（以1周时间计算）");
      } else {
        var params = new FormData();
        params.append("memberRightId", id);
        params.append("hospital", this.inputHosp);
        params.append("department", this.inputKS);
        params.append("illness", this.inputInfo);
        params.append("hospital_card_number", this.inputNum);
        params.append("booking_date", this.inputTime);
        params.append("hospital_visit_type", this.radioVal);
        params.append("remark", this.inputTip);
        axios.post(HPV_URL + "/api/bookings/", params).then(res => {
          this.$router.push({
            path: "/success"
          });
        });
      }
    },
    setItem() {
      sessionStorage.setItem("inputHosp", this.inputHosp);
      sessionStorage.setItem("inputKS", this.inputKS);
      sessionStorage.setItem("inputInfo", this.inputInfo);
      sessionStorage.setItem("inputNum", this.inputNum);
      sessionStorage.setItem("inputTime", this.inputTime);
      sessionStorage.setItem("inputTip", this.inputTip);
    }
  }
};
</script>

<style scoped>
.title {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  display: flex;
}
.title span {
  width: 5px;
  height: 16px;
  display: block;
  background: #e24709;
  margin: 17px 10px 0 20px;
}
.info {
  margin-left: 20px;
  font-size: 14px;
  display: flex;
  line-height: 28px;
}
.info p {
  color: #4a4a4a;
  width: 80px;
}
.info span {
  color: #333;
}
.tit2 {
  font-size: 16px;
  margin: 20px;
}
.tit2 span {
  font-size: 12px;
  color: #e24709;
}
.tits {
  margin-top: 0px;
}
label {
  font-size: 14px;
  display: block;
  margin: 0 0 5px 20px;
}
input {
  width: 14px;
  height: 14px;
  line-height: 14px;
  margin: 1px 5px 0 0;
}
.text {
  margin: 0 20px;
}
.address {
  height: 34px;
  line-height: 34px;
  width: 100%;
  border-radius: 5px;
  border: 1px solid #979797;
  font-size: 12px;
  padding-left: 10px;
}
textarea {
  width: 100%;
  height: 75px;
  border-radius: 5px;
  border: 1px solid #979797;
  font-size: 12px;
  padding-left: 10px;
}
.btn {
  margin: 20px 20px;
}
.btn button {
  height: 48px;
  line-height: 48px;
  font-size: 18px;
  margin-top: 20px;
  text-align: center;
  background: #e24709;
  color: #fff;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/hospital.vue